import type { IconData } from '../../types';

export const data: IconData = {
  o: '<path d="M61 23c0 5-1 10-4 14-1 1-3 0-3-1a24 24 0 0 0-36-21c-1 1-3-1-2-2C20 5 29 0 38 0c12 1 22 11 23 23zm9 37c5-9 5-19 0-26-1-2-3-1-3 0 0 5-1 9-3 13-7 11-21 15-33 9-1-1-3 0-2 2 2 4 6 7 10 10 11 5 24 2 31-8zM3 57c4 9 13 14 22 13 2 0 2-2 1-3-4-2-7-5-9-9-7-11-3-26 8-32 2-1 1-3 0-3-5 0-10 1-14 3C1 33-3 46 3 57z"/>',
  f: '<path d="M61 23c0 5-1 10-4 14-1 1-3 0-3-1a24 24 0 0 0-36-21c-1 1-3-1-2-2C20 5 29 0 38 0c12 1 22 11 23 23zm9 37c5-9 5-19 0-26-1-2-3-1-3 0 0 5-1 9-3 13-7 11-21 15-33 9-1-1-3 0-2 2 2 4 6 7 10 10 11 5 24 2 31-8zM3 57c4 9 13 14 22 13 2 0 2-2 1-3-4-2-7-5-9-9-7-11-3-26 8-32 2-1 1-3 0-3-5 0-10 1-14 3C1 33-3 46 3 57z"/>',
  vb: '0 0 75 75',
};

export default data;
